module.exports = __webpack_public_path__ + "img/personal_accident.9709d314.svg";